import React from "react";
import AnimatedSection from "./AnimatedSection";
import { useTranslation } from "react-i18next";
import "../i18n"; // Import i18n setup

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <section id="privacy-policy" className="py-16 text-white">
            {/* <AnimatedSection> */}
            <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
                <div className="py-10 mx-auto">
                    <h1 className="text-center text-3xl sm:text-4xl font-extrabold mb-6">
                        PRIVACY POLICY
                    </h1>

                    <p className="text-base sm:text-lg mb-4">
                        Welcome to Decimic Inc. Your privacy is important to us, and we are committed to safeguarding your personal information.
                        This Privacy Policy explains or outlines how we collect, use, and protect your personal data during you interact with our website, services, and products.

                    </p>

                    <p className="text-base sm:text-lg mb-6">
                        By accessing or using our website or services, you agree to the collection and use of information in accordance with this policy.
                    </p>
                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4">
                            1. Information We Collect
                        </h2>

                        <p className="mb-4">
                            We collect the following different types of information:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Personal Information:</p>
                                <p className="text-base leading-relaxed">
                                    When you register on our website, contact us, engage with our legal services, or make a purchase software products,
                                    we may collect personal information such as your name, contact details (email address, phone number), legal documents,
                                    billing/shipping address, payment details, and other information.
                                </p>
                            </div>

                            <div>
                                <p className="font-bold text-lg mb-1">Non-Personal Information/Usage Data:</p>
                                <p className="text-base leading-relaxed">
                                    We may collect non-identifiable data regarding how you access and use our website and services such as browser type,
                                    device information, IP address, browsing behavior and operating system.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Cookies & Tracking Technologies:</p>
                                <p className="text-base leading-relaxed">
                                    We use cookies, similar technologies and other tracking technologies to monitor activity on our website, analyze website traffic,
                                    improve functionality, enhance your experience on our website, personalize your experience and gather analytics on usage patterns.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Information We Collect */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            2. How We Use Your Information
                        </h2>

                        <p className="mb-4">
                            The information we collect may be used for the following purposes:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Software Services:</p>
                                <p className="text-base leading-relaxed">
                                    - To provide, improve, and support our software products and services.
                                    - To offer software development, technical support, updates, and user experience enhancements.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Legal Services:</p>
                                <p className="text-base leading-relaxed">
                                    - To provide legal advice, consultations, and representation.
                                    - To fulfill contractual obligations regarding legal matters.
                                    - To comply with regulatory requirements related to legal services.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Customer Communication & Support:</p>
                                <p className="text-base leading-relaxed">
                                    - To respond to inquiries, process transactions, and send service-related notifications.
                                    - To provide customer support and resolve issues.
                                    - To communicate regarding service updates, policy changes, and technical notices.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Marketing & Personalization:</p>
                                <p className="text-base leading-relaxed">
                                    - To send promotional materials and updates related to our services, subject to your preferences.
                                    - To improve and personalize your experience on our website.
                                    - To provide personalized recommendations and promotions.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Analytics & Security:</p>
                                <p className="text-base leading-relaxed">
                                    - To analyze website usage and track performance for improvement.
                                    - To detect fraud, prevent unauthorized access, and enhance security.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Legal Compliance & Dispute Resolution:</p>
                                <p className="text-base leading-relaxed">
                                    - To comply with applicable legal, regulatory, and compliance obligations, including anti-money laundering laws.
                                    - To resolve disputes and enforce agreements.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of How We Use Your Information */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            3. Data Security
                        </h2>

                        <p className="mb-4">
                            We implement industry-standard technical, administrative, and physical safeguards to protect your personal data from unauthorized access,
                            loss, misuse, alteration, or disclosure. While we take all reasonable measures to ensure security, no method of transmission or storage
                            over the internet is completely secure. Therefore, we cannot guarantee absolute protection, but we continuously work to enhance our security practices.
                        </p>
                    </div>
                    {/* End of Data Security */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            4. Sharing Your Information
                        </h2>

                        <p className="mb-4">
                            We do not sell, rent, or lease your personal information. However, we may share it in the following cases:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Trusted Service Providers:</p>
                                <p className="text-base leading-relaxed">
                                    We may share your information with third-party service providers (e.g., payment processors, logistics partners,
                                    software developers, legal service providers, and customer support) to fulfill orders, improve our services, and
                                    support business operations. These partners are bound by confidentiality agreements.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Legal Compliance:</p>
                                <p className="text-base leading-relaxed">
                                    We may disclose your information if required by law, court order, regulatory authority, or legal process to protect our
                                    rights, respond to legal claims, or comply with applicable regulations.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Marketing Partners (With Consent):</p>
                                <p className="text-base leading-relaxed">
                                    If you provide consent, we may share your data with marketing partners to offer relevant promotions and personalized recommendations.
                                </p>
                            </div>
                        </div>
                        <p className="mb-4">
                            We ensure that any shared data is handled securely and in compliance with privacy regulations.
                        </p>
                    </div>
                    {/* End of Sharing Your Information */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            5. Your Rights & Choices
                        </h2>

                        <p className="mb-4">
                            You have the following rights regarding your personal data:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Access & Correction:</p>
                                <p className="text-base leading-relaxed">
                                    You can request access to the personal information we hold about you and request corrections if it is inaccurate or incomplete.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Deletion:</p>
                                <p className="text-base leading-relaxed">
                                    You can request the deletion of your personal data, subject to legal retention requirements.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Opt-out of Marketing:</p>
                                <p className="text-base leading-relaxed">
                                    You may opt out of receiving marketing communications at any time.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Restrict or Object to Processing:</p>
                                <p className="text-base leading-relaxed">
                                    You can object to or request restrictions on the processing of your personal data.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Withdraw Consent:</p>
                                <p className="text-base leading-relaxed">
                                    Where applicable, you can withdraw your consent for data processing at any time.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Manage Cookies:</p>
                                <p className="text-base leading-relaxed">
                                    You can disable cookies through your browser settings.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Appeal Processing Decisions:</p>
                                <p className="text-base leading-relaxed">
                                    You have the right to appeal decisions regarding the processing of your personal data.
                                </p>
                            </div>
                        </div>
                        <p className="mb-4">
                            To exercise any of these rights or for further inquiries, please contact us at contact@decimic.com
                        </p>
                    </div>
                    {/* end of Your Rights & Choices */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            6. Cookies and Tracking Technologies
                        </h2>

                        <p className="mb-4">
                            We use cookies and similar tracking technologies to enhance your browsing experience, analyze website usage, and improve our products and services.
                            Cookies are small text files stored on your device that help us recognize your browser and optimize website functionality.
                        </p>
                        <p className="mb-4">
                            You can manage your cookie preferences through your browser settings. However, disabling cookies may affect certain features and performance of our website.
                        </p>
                    </div>
                    {/* End of Cookies and Tracking Technologies */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            7. Third-Party Links
                        </h2>

                        <p className="mb-4">
                            Our website may contain links to third-party websites, services, or content that we do not operate or control. We are not responsible for their privacy practices,
                            security, or content. If you choose to access these third-party services, they may collect or process your personal data. We strongly recommend reviewing their privacy
                            policies before providing any personal information.
                        </p>
                    </div>
                    {/* End of Third-Party Links */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            8. Children’s Privacy
                        </h2>

                        <p className="mb-4">
                            Our services are not intended for individuals under the age of 16, and we do not knowingly collect or solicit personal information from children under 16.
                            If we discover that we have inadvertently collected personal information from a child under 16, we will take immediate steps to delete such information.
                        </p>
                    </div>
                    {/* End of Children’s Privacy */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            9. Updates and Renewal to This Privacy Policy
                        </h2>

                        <p className="mb-4">
                            We may update or modify this Privacy Policy from time to time. Any changes will be posted on this page, and the <span className="font-bold">"Effective Date"</span> will be updated accordingly.
                            We encourage you to review this policy periodically to stay informed about how we protect your data.
                        </p>
                    </div>
                    {/* End of Updates and Renewal to This Privacy Policy */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            10. Contact Us
                        </h2>

                        <p className="mb-4">
                            If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
                        </p>
                        <p className="mb-4">
                            Decimic Inc
                            3-119-2, Miyagayato, Minuma Ku, Saitama Shi, Saitama, 337-0011, Japan
                            contact@decimic.com
                            Tel: +81-48-716-4543
                        </p>
                    </div>
                    {/* End of Updates and Renewal to This Privacy Policy */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            11. Copyright Notice
                        </h2>

                        <p className="mb-4">
                            © Decimic Inc. All rights reserved.
                        </p>
                        <p className="mb-4">
                            This Privacy Policy and its contents are protected by copyright law. No part of this policy may be reproduced or distributed
                            without the express written consent of Decimic Inc.
                        </p>
                    </div>
                    {/* End of Updates and Renewal to This Privacy Policy */}

                </div>
            </div>
            {/* </AnimatedSection> */}
        </section>
    );
};

export default PrivacyPolicy;